// istanbul ignore file
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const generateLinksClassNames = ({
  extraClass,
  active,
  small,
}) => classNames(
  'link',
  {
    'link--active': active,
    'link--small': small,
    [`${extraClass}`]: extraClass,
  },
);

const Link = ({
  children,
  link,
  anchor,
  active,
  title,
  extraClass,
  small,
  onClick,
  target,
  rel,
  testAttribute,
  ariaLabel
}) => (
  <a
    data-test={testAttribute}
    title={title}
    href={link || anchor}
    className={generateLinksClassNames({ extraClass, active, small })}
    onClick={e => onClick && onClick(e)}
    aria-label={ariaLabel}
    target={target}
    rel={rel}
  >
    {children}
  </a>
);

Link.propTypes = {
  children: PropTypes.node.isRequired,
  link: PropTypes.string,
  anchor: PropTypes.string,
  active: PropTypes.bool,
  title: PropTypes.string,
  extraClass: PropTypes.string,
  small: PropTypes.bool,
  onClick: PropTypes.func,
  target: PropTypes.string,
  rel: PropTypes.string,
  testAttribute: PropTypes.string,
  ariaLabel: PropTypes.string
};

export default Link;
